import React, { useEffect, useState } from 'react';
import api from '../../config/api';
import './AdminOrders.css';

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await api.get('/admin/orders');
      setOrders(response.data?.orders || []);
    } catch (error) {
      console.error('Failed to fetch orders:', error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (orderId, field, value) => {
    try {
      await api.put(`/admin/orders/${orderId}/status`, { [field]: value });
      await fetchOrders();
    } catch (error) {
      alert('Failed to update order status');
    }
  };

  if (loading) {
    return <div className="loading">Loading orders...</div>;
  }

  return (
    <div className="admin-orders">
      <h1>Orders</h1>
      
      <div className="orders-table">
        <table>
          <thead>
            <tr>
              <th>Order #</th>
              <th>Customer</th>
              <th>Total</th>
              <th>Payment Status</th>
              <th>Order Status</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders && orders.map(order => (
              <tr key={order.id}>
                <td>{order.order_number}</td>
                <td>{order.customer_name}<br /><small>{order.customer_email}</small></td>
                <td>${parseFloat(order.total || 0).toFixed(2)}</td>
                <td>
                  <select
                    value={order.payment_status}
                    onChange={(e) => handleStatusUpdate(order.id, 'payment_status', e.target.value)}
                  >
                    <option value="pending">Pending</option>
                    <option value="paid">Paid</option>
                    <option value="failed">Failed</option>
                    <option value="refunded">Refunded</option>
                  </select>
                </td>
                <td>
                  <select
                    value={order.order_status}
                    onChange={(e) => handleStatusUpdate(order.id, 'order_status', e.target.value)}
                  >
                    <option value="pending">Pending</option>
                    <option value="processing">Processing</option>
                    <option value="shipped">Shipped</option>
                    <option value="delivered">Delivered</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </td>
                <td>{new Date(order.created_at).toLocaleDateString()}</td>
                <td>
                  <button onClick={() => setSelectedOrder(order)} className="btn-small">View</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedOrder && (
        <div className="order-modal">
          <div className="modal-content">
            <h2>Order Details - {selectedOrder.order_number}</h2>
            <button onClick={() => setSelectedOrder(null)} className="close-btn">×</button>
            
            <div className="order-details">
              <div className="detail-section">
                <h3>Customer Information</h3>
                <p><strong>Name:</strong> {selectedOrder.customer_name}</p>
                <p><strong>Email:</strong> {selectedOrder.customer_email}</p>
                {selectedOrder.customer_phone && <p><strong>Phone:</strong> {selectedOrder.customer_phone}</p>}
              </div>

              <div className="detail-section">
                <h3>Shipping Address</h3>
                <p>{selectedOrder.shipping_address}</p>
              </div>

              <div className="detail-section">
                <h3>Order Items</h3>
                <table>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrder.items && selectedOrder.items.map(item => (
                      <tr key={item.id}>
                        <td>{item.product_name}</td>
                        <td>${parseFloat(item.product_price || 0).toFixed(2)}</td>
                        <td>{item.quantity}</td>
                        <td>${parseFloat(item.subtotal || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="detail-section">
                <h3>Order Summary</h3>
                <p><strong>Subtotal:</strong> ${parseFloat(selectedOrder.subtotal || 0).toFixed(2)}</p>
                <p><strong>Shipping:</strong> ${parseFloat(selectedOrder.shipping_cost || 0).toFixed(2)}</p>
                <p><strong>Tax:</strong> ${parseFloat(selectedOrder.tax || 0).toFixed(2)}</p>
                <p><strong>Total:</strong> ${parseFloat(selectedOrder.total || 0).toFixed(2)}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminOrders;

